var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import widgetTransformer from '@nykaa/deals-transformer';
import personalizationUtil from '@nykaa/deals-utils/personalization';
import platforms from './constants';
const personalizationAPI = {
    endPoint: 'inventory/data/json/',
    method: 'POST',
};
const apiService = {
    getPersonalizedData: (ApiHelper, data, apiURL, variants = {}, store, isDesktop, debug = false, pageData, contextPayload) => __awaiter(void 0, void 0, void 0, function* () {
        const platform = isDesktop ? platforms.DWEB : platforms.MWEB;
        const newVariants = Object.assign(Object.assign({}, variants), { debug, dn_platform: platform });
        const inventories = [];
        const queryString = Object.keys(newVariants).map((key) => `${key}=${newVariants[key]}`).join('&');
        const existingInventoryTrackingDataMap = {};
        data.forEach((item) => {
            if (item.personalization && (personalizationUtil.isPartialPersonalization(item.personalization)
                || personalizationUtil.isFullPersonalization(item.personalization))) {
                const { inventoryPageSection, inventoryId, inventoryPageType, widgetData, inventoryPageData, position = 0, } = item;
                const inventory = {
                    page_type: inventoryPageType,
                    page_section: inventoryPageSection,
                    page_data: inventoryPageData,
                    query_id: inventoryId,
                    dn_inventory_position: position,
                };
                inventories.push(inventory);
                if (widgetData) {
                    existingInventoryTrackingDataMap[inventoryId] = {
                        store: widgetData.store,
                        pagePrefix: widgetData.pagePrefix,
                        position,
                    };
                }
            }
        });
        if (inventories.length === 0) {
            return data.map((item) => (Object.assign(Object.assign({}, item), { isDataPersonalized: true })));
        }
        try {
            const response = yield ApiHelper(`${apiURL}/${personalizationAPI.endPoint}?${queryString}`, personalizationAPI.method, {
                inventories,
                store,
                platform,
                page_data: pageData,
                context: contextPayload,
            });
            const result = (response && response.data && response.data.result)
                ? response.data.result : [];
            const personalizedInventoriesMap = {};
            result.forEach((item) => {
                if (item.inventories && item.inventories['0']) {
                    const newInventory = item.inventories['0'];
                    const existingInventoryTrackingData = existingInventoryTrackingDataMap[newInventory.inventory_id] || {};
                    const { widgets = [] } = widgetTransformer([item.inventories['0']], isDesktop, existingInventoryTrackingData.store, existingInventoryTrackingData.pagePrefix, existingInventoryTrackingData.position - 1);
                    personalizedInventoriesMap[item.query_id] = widgets;
                }
            });
            const finalData = data.map((item) => {
                const { inventoryId, } = item;
                if (personalizedInventoriesMap[inventoryId] && personalizedInventoriesMap[inventoryId][0]) {
                    return (Object.assign(Object.assign(Object.assign({}, item), personalizedInventoriesMap[inventoryId][0]), { isDataPersonalized: true }));
                }
                return (Object.assign(Object.assign({}, item), { isDataPersonalized: true }));
            });
            return finalData;
        }
        catch (error) {
            return data.map((item) => (Object.assign(Object.assign({}, item), { isDataPersonalized: true })));
        }
    }),
    getPaginatedWidgets: (ApiHelper, apiURL, params) => __awaiter(void 0, void 0, void 0, function* () {
        const newParams = Object.assign(Object.assign({}, params), { api_version: 'V2' });
        const queryString = Object.keys(newParams).map((key) => `${key}=${newParams[key]}`).join('&');
        const endPoint = 'inventory/data/json/';
        try {
            const response = yield ApiHelper(`${apiURL}/${endPoint}?${queryString}`, 'get');
            const result = (response && response.data && response.data.result)
                ? response.data.result : [];
            return result;
        }
        catch (error) {
            throw new Error(error);
        }
    }),
};
export default apiService;
